import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Lesson_createSession($sessionData: CreateSession) {
    Lesson_createSession(sessionData: $sessionData) {
      id
      name
      position
      isDraft
      description
      date
      time
      address
      meetUrl
      isPrivate
    }
  }
`;

const LessonCreateSession = async sessionData =>
  graphql(mutation, { sessionData }).then(
    // eslint-disable-next-line camelcase
    ({ Lesson_createSession }) => Lesson_createSession
  );

export default LessonCreateSession;
